import {Button, Col, Form, Input, message, Modal, Row, Select, Space, Spin, Table, Tabs, Tag, Tooltip} from 'antd';
import {
    CalendarOutlined,
    ClockCircleOutlined,
    ExclamationCircleOutlined,
    RetweetOutlined,
    SearchOutlined
} from "@ant-design/icons";
import {WorkbasketTableDto} from "../../../dto/admin/WorkbasketTableDto";
import React, {useRef, useState} from "react";
import dayjs from "dayjs";
import {
    ADMIN_VERIFICATION_TYPE,
    API_RESPONSE_STATUS,
    BASKET_STATUS_ON_BOARDING_BASKET,
    BASKET_STATUS_ORIGINALLY_SEEN,
    HH_MM,
    IDENTIFICATION_SOURCE,
    NOT_AVAILABLE,
    TRANSFER_TYPE,
    YYYY_MM_DD,
    YYYY_MM_DD_HH_MM
} from "../../../util/Constants";
import modal from "antd/es/modal";
import adminService from "../../../service/adminService";
import {FilterConfirmProps} from "antd/es/table/interface";
import Highlighter from "react-highlight-words";
import {MSG_FAILED_TO_TRANSFER_DETAIL_VERIFICATION_ERROR, MSG_TASK_TRANSFER_SUCCESS} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import {AdminRequestDto} from "../../../dto/admin/AdminRequestDto";
import {Link} from "react-router-dom";
import {DropdownListDto} from "../../../dto/DropdownListDto";
import {EyeOutlined, FileTextOutlined, VideoCameraOutlined} from '@ant-design/icons/lib';
import {InputRef} from "antd/es/input";
import CommonFunction from "../../../util/CommonFunction";
import TextArea from "antd/es/input/TextArea";

interface CustomerVerificationTableProps {
    tableData: WorkbasketTableDto[],
    isMyWorkBasket: boolean,
    tableUpdateFunc: (data: boolean) => void,
}

type DataIndex = keyof WorkbasketTableDto;
const CustomerVerificationTable = (props: CustomerVerificationTableProps) => {
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef<InputRef>();
    const [isTransferModalOpen, setTransferModalOpen] = useState<boolean>(false);
    const [isRemarkModalOpen, setRemarkModalOpen] = useState<boolean>(false);
    const [transferUsernameDoc, setTransferUsernameDoc] = useState<string>();
    const [transferUsernameVideo, setTransferUsernameVideo] = useState<string>();
    const [isSpinnerLoading, setSpinnerLoading] = useState(false);
    const [selectedRow, setSelectedRow] = useState<WorkbasketTableDto>();
    const [activeUserList, setActiveUserList] = useState<DropdownListDto[]>();


    const [docForm] = Form.useForm();
    const [rejectForm] = Form.useForm();
    const [videoForm] = Form.useForm();
    const {TabPane} = Tabs;
    const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: DataIndex,
    ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters: () => void, dataIndex: DataIndex) => {
        clearFilters();
        setSearchText('');
        setSearchedColumn(dataIndex);
    };

    const handleCancel = () => {
        setRemarkModalOpen(false)
    }
    const getColumnSearchProps = (dataIndex: DataIndex, columnName: string): {
        filterDropdown: ({
                             setSelectedKeys,
                             selectedKeys,
                             confirm,
                             clearFilters,
                             close
                         }: { setSelectedKeys: any; selectedKeys: any; confirm: any; clearFilters: any; close: any }) =>
            JSX.Element;
        filterIcon: (filtered: boolean) => JSX.Element;
        onFilter: (value: any, record: any) => boolean;
        render: (text: any) =>
            any;
        onFilterDropdownOpenChange: (visible: any) => void
    } => ({
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters, close}) => (
            <div style={{padding: 8}} onKeyDown={(e) => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${columnName}`}
                    value={selectedKeys[0]}
                    onChange={(e: {
                        target: { value: React.Key; };
                    }) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                    style={{marginBottom: 8, display: 'block'}}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        icon={<SearchOutlined/>}
                        size="small"
                        style={{width: 90}}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters, dataIndex)}
                        size="small"
                        style={{width: 90}}
                    >
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        Close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{color: filtered ? '#1677ff' : undefined}}/>
        ),
        onFilter: (value, record) => {
            const dataIndexValue = record[dataIndex];

            if (dataIndexValue !== undefined && dataIndexValue !== null) {
                return dataIndexValue
                    .toString()
                    .toLowerCase()
                    .includes((value as string).toLowerCase());
            }
            return false
        },
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{backgroundColor: '#ffc069', padding: 0}}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    const getAdminUsersByType = (type: TRANSFER_TYPE) => {
        adminService.getAdminUsersByType(type).then((res) => {
            if (null != res.data.results) {
                let results = res.data.results;
                setActiveUserList(results.activeItemList)
            }
        }).catch((reason) => {
            ErrorHandler.handleError(reason);
        });
    }

    const getColor = (identificationSourceType: string) => {
        switch (identificationSourceType) {
            case IDENTIFICATION_SOURCE.NIC: {
                return 'green';
            }
            case IDENTIFICATION_SOURCE.PP: {
                return 'geekblue';
            }
            case IDENTIFICATION_SOURCE.DL: {
                return 'volcano';
            }
            default: {
                return '#8c8c8c';
            }
        }
    }


    const columns = [
        {
            title: 'No',
            dataIndex: 'key',
            render: (text: any, rec: any, index: number) => {
                return (<span>{index + 1}</span>)
            }
        },
        {
            title: 'Customer Name',
            dataIndex: 'customerName',
            key: 'customerName',
            sorter: (a: any, b: any) => {
                a = a.customerName == null ? '' : a.customerName
                b = b.customerName == null ? '' : b.customerName
                return a.localeCompare(b);
            },
            ...getColumnSearchProps('customerName', 'Customer Name'),
        },
        {
            title: 'RM Code',
            dataIndex: 'rmCode',
            key: 'rmCode',
            sorter: (a: any, b: any) => (a.rmCode - b.rmCode),
            ...getColumnSearchProps('rmCode', 'RM Code'),
            render: (text: any, rec: any) => {
                return (
                    <span>{CommonFunction.validateText(text)}</span>
                )
            },
        },
        {
            title: 'Onboarded By',
            dataIndex: 'basketStatus',
            key: 'basketStatus',
            align: 'center',
            sorter: (a: any, b: any) => {
                a = a.basketStatus == null ? '' : a.basketStatus
                b = b.basketStatus == null ? '' : b.basketStatus
                return a.localeCompare(b);
            },
            filters: [
                {
                    value: 'ORIGINALLY_SEEN',
                    text: "RELATIONSHIP MANAGER",
                },
                {
                    value: 'ON_BOARDING_BASKET',
                    text: "CUSTOMER",
                }
            ],
            onFilter: (value: string, record: any) => record.basketStatus === value,
            render: (text: any, rec: any) => {
                return (getTag(text))
            }
        },
        {
            title: 'Scheduled Date',
            dataIndex: 'verificationScheduleDto',
            key: 'verificationScheduleDto',
            align: 'center',
            className: props.isMyWorkBasket ? "displayNone" : "displayFlex",
            sorter: (a: any, b: any) => {
                a = a.verificationScheduleDto.requestedDate == null ? '' : a.verificationScheduleDto.requestedDate
                b = b.verificationScheduleDto.requestedDate == null ? '' : b.verificationScheduleDto.requestedDate
                return a.localeCompare(b);
            },
            render: (text: any) => (
                <span>{null != text ? (<span><CalendarOutlined
                    style={{marginRight: 8, opacity: 0.8}}/>
                    {dayjs(text.requestedDate).format(YYYY_MM_DD)}</span>) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'Scheduled Time Slot',
            dataIndex: 'verificationScheduleDto',
            key: 'verificationScheduleDto',
            className: props.isMyWorkBasket ? "displayNone" : "displayFlex",
            align: 'center',
            sorter: (a: any, b: any) => {
                a = a.verificationScheduleDto.requestedStartTime == null ? '' : a.verificationScheduleDto.requestedStartTime
                b = b.verificationScheduleDto.requestedStartTime == null ? '' : b.verificationScheduleDto.requestedStartTime
                return a.localeCompare(b);
            },
            render: (text: any, rec: any) => (
                <span>{null != text ? (<span><ClockCircleOutlined
                    style={{
                        marginRight: 8,
                        opacity: 0.8
                    }}/>{dayjs(text.requestedDate + " " + text.requestedStartTime).format(HH_MM)
                    + " - " + dayjs(text.requestedDate + " " + text.requestedEndTime).format(HH_MM)}</span>) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'Identification Type',
            key: 'identificationType',
            dataIndex: 'identificationType',
            align: 'center',
            sorter: (a: any, b: any) => {
                a = a.identificationType == null ? '' : a.identificationType
                b = b.identificationType == null ? '' : b.identificationType
                return a.localeCompare(b);
            },
            filters: [
                {
                    value: IDENTIFICATION_SOURCE.NIC,
                    text: "NIC",
                },
                {
                    value: IDENTIFICATION_SOURCE.DL,
                    text: "DRIVING LICENSE",
                },
                {
                    value: IDENTIFICATION_SOURCE.PP,
                    text: "PASSPORT",
                }
            ],
            onFilter: (value: string, record: any) => record.identificationType === value,
            render: (text: any) => {
                return (
                    <Tag
                        className={getClassName(text)}
                        color={getColor(text)} key={text}>
                        {null != text ? text.toUpperCase() : 'N/A'}
                    </Tag>
                )
            }
        },
        {
            title: 'Identification No',
            dataIndex: 'identificationNumber',
            key: 'identificationNumber',
            sorter: (a: any, b: any) => {
                a = a.identificationNumber == null ? '' : a.identificationNumber
                b = b.identificationNumber == null ? '' : b.identificationNumber
                return a.localeCompare(b);
            },
            ...getColumnSearchProps('identificationNumber', "Identification No"),
            render: (text: any) => {
                return treatNullValuesInTable(text)
            },
        },
        {
            title: 'Residency Status',
            dataIndex: 'residencyStatus',
            key: 'residencyStatus',
            sorter: (a: any, b: any) => {
                a = a.residencyStatus == null ? '' : a.residencyStatus
                b = b.residencyStatus == null ? '' : b.residencyStatus
                return a.localeCompare(b);
            },
            ...getColumnSearchProps('residencyStatus', 'Residency Status'),
        },
        {
            title: 'API Status',
            dataIndex: 'apiResponseStatus',
            key: 'apiResponseStatus',
            align: "center",
            hidden: !props.isMyWorkBasket,
            sorter: (a: any, b: any) => {
                a = a.apiResponseStatus == null ? '' : a.apiResponseStatus
                b = b.apiResponseStatus == null ? '' : b.apiResponseStatus
                return a.localeCompare(b);
            },
            filters: [
                {
                    text: API_RESPONSE_STATUS.PENDING,
                    value: API_RESPONSE_STATUS.PENDING,
                },
                {
                    text: API_RESPONSE_STATUS.FAILED,
                    value: API_RESPONSE_STATUS.FAILED,
                },

            ],
            onFilter: (value: string, record: any) => record.apiResponseStatus.indexOf(value) === 0,
            render: (text: string, rec: any) => (
                <>
                    {
                        text === API_RESPONSE_STATUS.FAILED ?
                            <Tag color="error">{API_RESPONSE_STATUS.FAILED}</Tag>
                            : text === API_RESPONSE_STATUS.PENDING ?
                                <Tag color="warning">
                                    {API_RESPONSE_STATUS.PENDING}
                                </Tag> :
                                <Tag color="default">
                                    N/A
                                </Tag>
                    }


                </>
            ),
        },
        {
            title: 'Created Datetime',
            dataIndex: 'createdDateTime',
            key: 'createdDateTime',
            sorter: (a: any, b: any) => {
                a = a.createdDateTime == null ? '' : a.createdDateTime
                b = b.createdDateTime == null ? '' : b.createdDateTime
                return a.localeCompare(b);
            },
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'Modified Datetime',
            dataIndex: 'modifiedDatetime',
            key: 'modifiedDatetime',
            sorter: (a: any, b: any) => {
                a = a.modifiedDatetime == null ? '' : a.modifiedDatetime
                b = b.modifiedDatetime == null ? '' : b.modifiedDatetime
                return a.localeCompare(b);
            },
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'Details & Document Verification Status',
            dataIndex: 'detailVerificationStatus',
            key: 'detailVerificationStatus',
            align: "center",
            sorter: (a: any, b: any) => {
                a = a.detailVerificationStatus == null ? '' : a.detailVerificationStatus
                b = b.detailVerificationStatus == null ? '' : b.detailVerificationStatus
                return a.localeCompare(b);
            },
            render: (text: any, rec: any) => (

                <Space size="middle">
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', minWidth: 204}}>
                        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center',
                            minWidth: checkValueNull(rec.detailRejectReason, rec.detailInternalRemark) ? 168: 204}}>
                            <Tag className='tbl-tag' color={getTagColor(text)} key={text} style={{marginLeft: checkValueNull(rec.detailRejectReason, rec.detailInternalRemark) ? 40: 0}}>
                                {text}
                            </Tag>
                        </div>
                        {checkValueNull(rec.detailRejectReason, rec.detailInternalRemark) ?
                            <Tooltip placement="topRight" title="View Info">
                                <Button className={'customer-verify-tbl-info'}
                                    type="text"
                                    icon={<ExclamationCircleOutlined className={'info-icon'}/>}
                                    onClick={() => viewRejectReasonAndRemark(rec.detailRejectReason, rec.detailInternalRemark)}
                                />
                            </Tooltip> :
                            <></>}
                    </div>
                </Space>
            ),
        },
        {
            title: 'Document Verification Assignee',
            dataIndex: 'detailVerificationAssignee',
            key: 'detailVerificationAssignee',
            sorter: (a: any, b: any) => {
                a = a.detailVerificationAssignee == null ? '' : a.detailVerificationAssignee
                b = b.detailVerificationAssignee == null ? '' : b.detailVerificationAssignee
                return a.localeCompare(b);
            },
            ...getColumnSearchProps('detailVerificationAssignee', 'Document Verification Assignee'),
            render: (text: any) => (
                treatNullValuesInTable(text)
            ),
        },
        {
            title: 'Document Verification Assigned Datetime',
            dataIndex: 'detailVerificationAssignedDateTime',
            key: 'detailVerificationAssignedDateTime',
            sorter: (a: any, b: any) => {
                a = a.detailVerificationAssignedDateTime == null ? '' : a.detailVerificationAssignedDateTime
                b = b.detailVerificationAssignedDateTime == null ? '' : b.detailVerificationAssignedDateTime
                return a.localeCompare(b);
            },
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'Video Verification Status',
            dataIndex: 'videoVerificationStatus',
            key: 'videoVerificationStatus',
            align: "center",
            sorter: (a: any, b: any) => {
                a = a.videoVerificationStatus == null ? '' : a.videoVerificationStatus
                b = b.videoVerificationStatus == null ? '' : b.videoVerificationStatus
                return a.localeCompare(b);
            },
            render: (text: any, rec: any) => (
                <Space size="middle">
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', minWidth: 204}}>
                        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center',
                            minWidth: checkValueNull(rec.videoRejectReason, rec.videoInternalRemark) ? 168: 204}}>
                            <Tag className={text === "RESCHEDULED" ? 'drl-tbl-tag' : 'tbl-tag'}
                                 style={{marginLeft: checkValueNull(rec.videoRejectReason, rec.videoInternalRemark) ? 40: 0 }}
                                 color={getTagColor(text)} key={text}>
                                {replaceUnderscore(text)}
                            </Tag>
                        </div>

                        <div>
                            {checkValueNull(rec.videoRejectReason, rec.videoInternalRemark) ?
                                <Tooltip placement="topRight" title="View Info" className={'customer-verify-tbl-info'}>
                                    <Button
                                        type="text"
                                        icon={<ExclamationCircleOutlined className={'info-icon'}/>}
                                        onClick={() => viewRejectReasonAndRemark(rec.videoRejectReason, rec.videoInternalRemark)}
                                    />
                                </Tooltip> :
                                <></>}
                        </div>
                    </div>
                </Space>
            ),
        },
        {
            title: 'Video Verification Assignee',
            dataIndex: 'videoVerificationAssignee',
            key: 'videoVerificationAssignee',
            sorter: (a: any, b: any) => {
                a = a.videoVerificationAssignee == null ? '' : a.videoVerificationAssignee
                b = b.videoVerificationAssignee == null ? '' : b.videoVerificationAssignee
                return a.localeCompare(b);
            },

            ...getColumnSearchProps('videoVerificationAssignee', 'Video Verification Assignee'),
            render: (text: any) => (
                treatNullValuesInTable(text)
            ),
        },
        {
            title: 'Video Verification Assigned Datetime',
            dataIndex: 'videoVerificationAssignedDateTime',
            key: 'videoVerificationAssignedDateTime',
            sorter: (a: any, b: any) => {
                a = a.videoVerificationAssignedDateTime == null ? '' : a.videoVerificationAssignedDateTime
                b = b.videoVerificationAssignedDateTime == null ? '' : b.videoVerificationAssignedDateTime
                return a.localeCompare(b);
            },
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'Customer Verification Status',
            dataIndex: 'customerVerificationStatus',
            key: 'customerVerificationStatus',
            align: "center",
            sorter: (a: any, b: any) => {
                a = a.customerVerificationStatus == null ? '' : a.customerVerificationStatus
                b = b.customerVerificationStatus == null ? '' : b.customerVerificationStatus
                return a.localeCompare(b);
            },
            render: (text: any, rec: any) => (
                <Space size="middle">
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', minWidth: 204}}>
                        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center',
                            minWidth: checkValueNull(rec.customerRejectReason, rec.customerInternalRemark) ? 168: 204}}>
                        <Tag className={text === "RESCHEDULED" ? 'drl-tbl-tag' : 'tbl-tag'}
                             style={{marginLeft: checkValueNull(rec.customerRejectReason, rec.customerInternalRemark) ? 40 : 0}}
                             color={getTagColor(text)} key={text}>
                            {replaceUnderscore(text)}
                        </Tag>
                        </div>

                        <div>
                            {checkValueNull(rec.customerRejectReason, rec.customerInternalRemark) ?
                                <Tooltip placement="topRight" title="View Info" className={'customer-verify-tbl-info'}>
                                    <Button
                                        type="text"
                                        icon={<ExclamationCircleOutlined className={'info-icon'}/>}
                                        onClick={() => viewRejectReasonAndRemark(rec.customerRejectReason, rec.customerInternalRemark)}
                                    />
                                </Tooltip> :
                                <></>}
                        </div>
                    </div>
                </Space>
            ),
        },
        {
            title: 'Customer Verification Assignee',
            dataIndex: 'customerVerificationAssignee',
            key: 'customerVerificationAssignee',
            sorter: (a: any, b: any) => {
                a = a.customerVerificationAssignee == null ? '' : a.customerVerificationAssignee
                b = b.customerVerificationAssignee == null ? '' : b.customerVerificationAssignee
                return a.localeCompare(b);
            },

            ...getColumnSearchProps('customerVerificationAssignee', 'Customer Verification Assignee'),
            render: (text: any) => (
                treatNullValuesInTable(text)
            ),
        },
        {
            title: 'Customer Verification Assigned Datetime',
            dataIndex: 'customerVerificationAssignedDateTime',
            key: 'customerVerificationAssignedDateTime',
            sorter: (a: any, b: any) => {
                a = a.customerVerificationAssignedDateTime == null ? '' : a.customerVerificationAssignedDateTime
                b = b.customerVerificationAssignedDateTime == null ? '' : b.customerVerificationAssignedDateTime
                return a.localeCompare(b);
            },
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'Action',
            key: 'action',
            align: "center",
            fixed: 'right' as const,
            render: (text: any, record: WorkbasketTableDto) => (
                <Space size="middle">
                    {!props.isMyWorkBasket ?
                        <Tooltip placement="top" title='Transfer'>
                            <Button className='btn-action-outline-common btn-action-transfer' icon={<RetweetOutlined/>}
                                    onClick={() => openTransferModal(record)}>Transfer</Button></Tooltip>
                        :
                        <Tooltip placement="top" title='View'>
                            <Link to={{
                                pathname: `/workflow/admin/customerVerificationDetails`,
                                state: record,
                            }}>
                                <Button className='btn-action-outline-common btn-action-view '
                                        onClick={() => localStorage.setItem("workBasketData", JSON.stringify(record))}
                                        icon={<EyeOutlined/>}>View</Button>
                            </Link>
                        </Tooltip>

                    }
                </Space>
            ),
        },
    ].filter(item => !item.hidden);
    const replaceUnderscore = (text: string) => {
        return text.toUpperCase().replaceAll('_', ' ')
    }

    const checkValueNull = (reason: string, remark: string) => {
        if ((null != reason && "" != reason)) {
            return true;
        }
        return false;
    }

    const viewRejectReasonAndRemark = (reason: string, remark: string) => {
        rejectForm.setFieldsValue({
            internalRemark: remark,
            rejectReason: reason,
        })
        setRemarkModalOpen(true)
    }
    const getTag = (status: string) => {
        switch (status) {
            case BASKET_STATUS_ORIGINALLY_SEEN: {
                return (
                    <Tag className={'drl-tbl-tag'}
                         color='#7cb305' key={status}>
                        RELATIONSHIP MANAGER
                    </Tag>
                )
            }
            case BASKET_STATUS_ON_BOARDING_BASKET: {
                return (
                    <Tag className={'drl-tbl-tag'}
                         color='#1d39c4' key={status}>
                        CUSTOMER
                    </Tag>
                )
            }

        }
    }
    const getClassName = (text: string) => {
        if (null != text) {
            return text.toUpperCase() == "DRIVING LICENSE" ? 'drl-tbl-tag' : 'tbl-tag'
        }
        return 'tbl-tag';
    }

    const getTagColor = (text: string) => {
        switch (text) {
            case "VERIFIED": {
                return "green";
            }
            case "ORIGINALLY_SEEN": {
                return "green";
            }
            case "RESCHEDULED": {
                return "orange";
            }
            case "PENDING": {
                return "yellow";
            }
            case "DECLINED": {
                return "#f5222de6";
            }
            case "REJECTED": {
                return "rgb(199, 44, 65)";
            }
        }
    }

    const treatNullValuesInTable = (value: string) => {
        if (null != value && '' != value) {
            return value;
        }
        return NOT_AVAILABLE;
    }

    const openTransferModal = (record: WorkbasketTableDto) => {
        setTransferModalOpen(true)
        setSelectedRow(record)
        docForm.setFieldsValue({userNameDoc: record.detailVerificationAssignee})
        videoForm.setFieldsValue({userNameVideo: record.videoVerificationAssignee})
        getAdminUsersByType(TRANSFER_TYPE.DETAIL)

    }
    const handleCancelTransferModal = () => {
        setTransferModalOpen(false)
        setSelectedUsernamesEmpty()
    }

    const setSelectedUsernamesEmpty = () => {
        setTransferUsernameVideo("")
        setTransferUsernameDoc("")
    }
    const submitTransfer = (isDocVerification: boolean) => {
        setTransferModalOpen(false)
        if (selectedRow) {
            modal.confirm({
                title: 'Confirm',
                className: 'confirm-dialog-box',
                icon: <ExclamationCircleOutlined/>,
                content: `Do you want to transfer this task to ${isDocVerification ? transferUsernameDoc : transferUsernameVideo}?`,
                okText: 'Yes',
                cancelText: 'No',
                okButtonProps: {style: {background: '#FF7400'}},
                onOk() {
                    setSpinnerLoading(true)
                    let adminRequestDto: AdminRequestDto = {
                        workId: selectedRow?.workId,
                        adminWorkType: isDocVerification ? ADMIN_VERIFICATION_TYPE.CUSTOMER_DETAIL_VERIFICATION :
                            ADMIN_VERIFICATION_TYPE.CUSTOMER_VIDEO_VERIFICATION,
                        username: isDocVerification ? transferUsernameDoc : transferUsernameVideo,
                    } as AdminRequestDto
                    adminService.customerAdminTransferVerificationWork(adminRequestDto).then(res => {
                        if (res.data !== null && res.data.results) {
                            message.success(MSG_TASK_TRANSFER_SUCCESS).then();
                            props.tableUpdateFunc(true)
                            setSpinnerLoading(false)
                            setSelectedUsernamesEmpty()
                        } else {
                            setTransferModalOpen(false)
                            message.error(MSG_FAILED_TO_TRANSFER_DETAIL_VERIFICATION_ERROR).then();
                            setSpinnerLoading(false)
                            setSelectedUsernamesEmpty()
                            setTransferModalOpen(true)
                        }
                    }, (reason) => {
                        setTransferModalOpen(false)
                        setSpinnerLoading(false)
                        ErrorHandler.handleError(reason);
                        setTransferModalOpen(true)

                    })
                },
                onCancel() {
                    setSelectedUsernamesEmpty()
                }
            });
        } else {
            console.log("selected row null")
        }
    }
    return (
        <>


            <Table size='small' scroll={{x: 'max-content'}} columns={columns} dataSource={props.tableData}/>
            <Modal destroyOnClose={true}
                   maskClosable={false}
                   title="Transfer Task"
                   open={isTransferModalOpen}
                   footer={[]}
                   width={600}
                   onCancel={handleCancelTransferModal}
                   className='transfer-modal'
                   centered
            >
                <Spin spinning={isSpinnerLoading} tip="Loading" size="large">
                    <Row gutter={8}>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Tabs type="card" defaultActiveKey={['1']} onChange={getAdminUsersByType}>
                                <TabPane tab={<><FileTextOutlined/> Document Verification</>}
                                         key={TRANSFER_TYPE.DETAIL}>
                                    <Form
                                        className='form-input attachments-upload-form'
                                        layout={"vertical"}
                                        form={docForm}
                                        onFinish={() => submitTransfer(true)}
                                    >
                                        <Form.Item
                                            name={"userNameDoc"}
                                            label="Username"
                                            rules={[{
                                                required: true,
                                                message: 'Please select username to transfer'
                                            }]}>
                                            <Select placeholder={"Select username"}
                                                    getPopupContainer={(trigger: {
                                                        parentNode: any;
                                                    }) => trigger.parentNode}
                                                    style={{width: '100%'}}
                                                    options={activeUserList?.map((user) => ({
                                                        value: user.value,
                                                        label: user.label,
                                                        disabled: user.value === selectedRow?.detailVerificationAssignee,
                                                    }))}
                                                    onChange={(e: string) => setTransferUsernameDoc(e)}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(input: any, option: {
                                                        label: any;
                                                    }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                            >

                                            </Select>
                                        </Form.Item>
                                        <Form.Item className='transfer-btn'>
                                            <Space style={{float: 'right'}}>
                                                <Button htmlType="submit" style={{
                                                    cursor: (transferUsernameDoc == undefined || transferUsernameDoc == "") ? "not-allowed" : "pointer"
                                                }}
                                                        disabled={transferUsernameDoc == undefined || transferUsernameDoc == ""}
                                                        type="success">Transfer</Button>
                                            </Space>
                                        </Form.Item>


                                    </Form>
                                </TabPane>
                                <TabPane tab={<><VideoCameraOutlined/> Video Verification</>} key={TRANSFER_TYPE.VIDEO}>
                                    <Form
                                        className='form-input attachments-upload-form'
                                        layout={"vertical"}
                                        form={videoForm}
                                        onFinish={() => submitTransfer(false)}
                                    >
                                        <Form.Item
                                            name={"userNameVideo"}
                                            label="Username"
                                            rules={[{
                                                required: true,
                                                message: 'Please select username to transfer'
                                            }]}>
                                            <Select placeholder={"Select username"}
                                                    getPopupContainer={(trigger: {
                                                        parentNode: any;
                                                    }) => trigger.parentNode}
                                                    style={{width: '100%'}}
                                                    options={activeUserList?.map((user) => ({
                                                        value: user.value,
                                                        label: user.label,
                                                        disabled: user.value === selectedRow?.videoVerificationAssignee,
                                                    }))}
                                                    onChange={(e: string) => setTransferUsernameVideo(e)}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(input: any, option: {
                                                        label: any;
                                                    }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                            />
                                        </Form.Item>
                                        <Form.Item className='transfer-btn'>
                                            <Space style={{float: 'right'}}>
                                                <Button htmlType="submit" style={{
                                                    cursor: (transferUsernameVideo == undefined || transferUsernameVideo == "") ? "not-allowed" : "pointer"
                                                }}
                                                        disabled={transferUsernameVideo == undefined || transferUsernameVideo == ""}
                                                        type="success">Transfer</Button>
                                            </Space>
                                        </Form.Item>


                                    </Form>
                                </TabPane>
                            </Tabs>

                        </Col>
                    </Row>
                </Spin>


            </Modal>
            <Modal destroyOnClose={true}
                   maskClosable={false}
                   title="Reject Reason / Internal Remark"
                   open={isRemarkModalOpen}
                   footer={[]}
                   onCancel={handleCancel}
            >

                <Form
                    className='form-input attachments-upload-form'
                    layout={"vertical"}
                    form={rejectForm}
                    preserve={false}
                    disabled={true}
                >
                    <Form.Item
                        name={"rejectReason"}
                        label={<b>Reject Reason</b>}>
                        <TextArea showCount placeholder="Please enter reject reason" maxLength={255}
                                  bordered={true}/>
                    </Form.Item>
                    <Form.Item
                        name={"internalRemark"}
                        label={<b>Internal Remark</b>}>
                        <TextArea showCount placeholder="Please enter internal remark" maxLength={255}
                                  bordered={true}/>
                    </Form.Item>

                </Form>
            </Modal>
        </>
    )
};


export default CustomerVerificationTable;
